const TOLGEE_GLOBALS = {
  winninName: {
    key: 'global-winninName',
    defaultValue: 'Winnin Intelligence',
  },
  quarterly: {
    key: 'quarterly',
    defaultValue: 'Trimestral',
  },
  biannual: {
    key: 'biannual',
    defaultValue: 'Semestral',
  },
  uploadedVideo: {
    key: 'global-uploadedVideos',
    defaultValue: 'Vídeos Carregados',
  },
  topic: {
    key: 'global-topic',
    defaultValue: 'Tópico',
  },
  topics: {
    key: 'global-topics',
    defaultValue: 'Tópicos',
  },
  musicTopics: {
    key: 'global-musicTopics',
    defaultValue: 'Tópicos de música',
  },
  music: {
    key: 'global-music',
    defaultValue: 'Música',
  },
  subtopic: {
    key: 'global-subtopic',
    defaultValue: 'Subtópico',
  },
  subtopics: {
    key: 'global-subtopics',
    defaultValue: 'Subtópicos',
  },
  musicSubtopics: {
    key: 'global-musicSubtopics',
    defaultValue: 'Subtópicos de música',
  },
  category: {
    key: 'global-category',
    defaultValue: 'Categoria',
  },
  relevance: {
    key: 'global-relevance',
    defaultValue: 'Relevância',
  },
  cancel: {
    key: 'global-cancel',
    defaultValue: 'Cancelar',
  },
  continue: {
    key: 'global-continue',
    defaultValue: 'Continuar',
  },
  choose: {
    key: 'global-choose',
    defaultValue: 'Choose',
  },
  apply: {
    key: 'global-apply',
    defaultValue: 'Aplicar',
  },
  back: {
    key: 'global-back',
    defaultValue: 'Voltar',
  },
  gender: {
    key: 'global-gender',
    defaultValue: 'Gênero',
  },
  age: {
    key: 'global-age',
    defaultValue: 'Idade',
  },
  done: {
    key: 'global-done',
    defaultValue: 'Feito',
  },
  seeNow: {
    key: 'global-seeNow',
    defaultValue: 'Ver agora',
  },
  seeMore: {
    key: 'global-seeMore',
    defaultValue: 'Ver mais',
  },
  sortBy: {
    key: 'global-sortBy',
    defaultValue: 'Ordenar por',
  },
  subscribers: {
    key: 'global-subscribers',
    defaultValue: 'Inscritos',
  },
  views: {
    key: 'global-views',
    defaultValue: 'Visualizações',
  },
  shares: {
    key: 'global-shares',
    defaultValue: 'Compartilhamentos',
  },
  likes: {
    key: 'global-likes',
    defaultValue: 'Curtidas',
  },
  comments: {
    key: 'global-comments',
    defaultValue: 'Comentários',
  },
  creator: {
    key: 'global-creator',
    defaultValue: 'Criadores',
  },
  creators: {
    key: 'global-creators',
    defaultValue: 'Criadores',
  },
  brand: {
    key: 'global-brand',
    defaultValue: 'Marca',
  },
  viewerBlockMessage: {
    key: 'global-viewerBlockMessage',
    defaultValue: 'You don´t have access to this... yet! To view this content, upgrade your account.',
  },
  seeAll: {
    key: 'global-seeAll',
    defaultValue: 'Ver todos',
  },
  '3MonthsValue': {
    key: 'global-3MonthsValue',
    defaultValue: 'Últimos 3 meses',
  },
  '6MonthsValue': {
    key: 'global-6MonthsValue',
    defaultValue: 'Últimos 6 meses',
  },
  '12MonthsValue': {
    key: 'global-12MonthsValue',
    defaultValue: 'Últimos 12 meses',
  },
  '24MonthsValue': {
    key: 'global-24MonthsValue',
    defaultValue: 'Últimos 2 anos',
  },
  '36MonthsValue': {
    key: 'global-36MonthsValue',
    defaultValue: 'Últimos 3 anos',
  },
  today: {
    key: 'global-today',
    defaultValue: 'Hoje',
  },
  last24hours: {
    key: 'global-last24hours',
    defaultValue: 'Últimas 24 horas',
  },
  lastSevenDays: {
    key: 'global-lastSevenDays',
    defaultValue: 'Últimos 7 dias',
  },
  lastFifteenDays: {
    key: 'global-lastFifteenDays',
    defaultValue: 'Últimos 15 dias',
  },
  lastThirtyDays: {
    key: 'global-lastThirtyDays',
    defaultValue: 'Últimos 30 dias',
  },
  defaultError: {
    key: 'global-defaultError',
    defaultValue: 'Oops! Ocorreu um erro, por favor tente novamente.',
  },
  toastErrorMessage: {
    key: 'global-toastErrorMessage',
    defaultValue: 'Oops! An error occurred, please try again.',
  },
  errorTextHeader: {
    key: 'global-errorTextHeader',
    defaultValue: 'Oops. Algo deu errado, por favor, tente novamente.',
  },
  tryAgain: {
    key: 'global-tryAgain',
    defaultValue: 'Tente novamente',
  },
  female: {
    key: 'global-female',
    defaultValue: 'Feminino',
  },
  male: {
    key: 'global-male',
    defaultValue: 'Masculino',
  },
  metrics: {
    key: 'global-metrics',
    defaultValue: 'Métricas',
  },
  export: {
    key: 'global-export',
    defaultValue: 'Exportar',
  },
  retry: {
    key: 'global-retry',
    defaultValue: 'Tentar novamente',
  },
  copy: {
    key: 'global-copy',
    defaultValue: 'Copiar',
  },
  copyLink: {
    key: 'global-copyLink',
    defaultValue: 'Copiar link',
  },
  anErrorOccurred: {
    key: 'global-anErrorOccurred',
    defaultValue: 'An error occurred.',
  },
  add: {
    key: 'global-add',
    defaultValue: 'Adicionar',
  },
  remove: {
    key: 'global-remove',
    defaultValue: 'Remover',
  },
  audienceReasoning: {
    key: 'global-audienceReasoning',
    defaultValue:
      'A demografia da audiência é estimada por nossa ferramenta de inteligência artificial própria, usando dados públicos de pessoas engajadas com esse conteúdo.',
  },
  allTime: {
    key: 'global-allTime',
    defaultValue: 'All time',
  },
  followers: {
    key: `global-followers`,
    defaultValue: 'Followers',
  },
  delete: {
    key: 'global-delete',
    defaultValue: 'Deletar',
  },
  changeContent: {
    key: 'global-changeContent',
    defaultValue: 'Mudar conteúdo',
  },
  duplicate: {
    key: 'global-duplicate',
    defaultValue: 'Duplicar',
  },
  save: {
    key: 'global-save',
    defaultValue: 'Salvar',
  },
  rename: {
    key: 'global-rename',
    defaultValue: 'Renomear',
  },
  clear: {
    key: 'global-clear',
    defaultValue: 'Limpar',
  },
  totalEngagement: {
    key: 'global-totalEngagement',
    defaultValue: 'Engajamento Total',
  },
  totalViews: {
    key: 'global-totalViews',
    defaultValue: 'Total de visualizações',
  },
  engagementAndViews: {
    key: 'global-engagementAndViews',
    defaultValue: 'Engajamento vs Visualizações',
  },
  noDataAvailable: {
    key: 'global-noDataAvailable',
    defaultValue: 'No data available',
  },
  video: {
    key: 'global-video',
    defaultValue: 'Vídeo',
  },
  videos: {
    key: 'global-videos',
    defaultValue: 'Vídeos',
  },
  videosNumber: {
    key: 'global-videos-number',
    defaultValue: 'Número de vídeos',
  },
  notFilteredByAudience: {
    key: 'global-notFilteredByAudience',
    defaultValue: 'Informação não filtrada por audiência',
  },
  worldCupWorkspace: {
    key: 'global-worldCupWorkspace',
    defaultValue: 'You can´t modify this workspace.',
  },
  watching: {
    key: 'global-watching',
    defaultValue: 'Assistindo',
  },
  live: {
    key: 'global-live',
    defaultValue: 'Ao vivo',
  },
  upcoming: {
    key: 'global-upcoming',
    defaultValue: 'A seguir',
  },
  liveEnded: {
    key: 'global-liveEnded',
    defaultValue: 'Transmissão encerrada',
  },
  scheduled: {
    key: 'global-scheduled',
    defaultValue: 'Agendado',
  },
  uploadDate: {
    key: 'global-uploadDate',
    defaultValue: 'Data de upload',
  },
  streamDate: {
    key: 'global-streamDate',
    defaultValue: 'Data de transmissão',
  },
  liveNow: {
    key: 'global-liveNow',
    defaultValue: 'Transmissão ao vivo',
  },
  waiting: {
    key: 'global-waiting',
    defaultValue: 'Esperando',
  },
  viewer: {
    key: 'global-viewer',
    defaultValue: 'Visualizador',
  },
  viewers: {
    key: 'global-viewers',
    defaultValue: 'Viewers',
  },
  dataComingSoon: {
    key: 'global-dataComingSoon',
    defaultValue: 'Dados de conteúdo em breve!',
  },
  previous: {
    key: 'global-previous',
    defaultValue: 'Previous',
  },
  next: {
    key: 'global-next',
    defaultValue: 'Próximo',
  },
  published: {
    key: 'global-published',
    defaultValue: 'Published',
  },
  about: {
    key: 'global-about',
    defaultValue: 'About',
  },
  average: {
    key: 'global-average',
    defaultValue: 'Média',
  },
  total: {
    key: 'global-total',
    defaultValue: 'Total',
  },
  measuredBy: {
    key: 'global-measuredBy',
    defaultValue: 'Medido por',
  },
  platformCommentsNotCollected: {
    key: 'global-platformCommentsNotCollected',
    defaultValue: 'Não podemos coletar comentários dessa plataforma no momento.',
  },
  platformViewsNotCollected: {
    key: 'global-platformViewsNotCollected',
    defaultValue: `Não podemos coletar visualizações dessa plataforma no momento.`,
  },
  platformMetricNotApplicable: {
    key: 'global-platformMetricNotApplicable',
    defaultValue: 'Essa métrica não é aplicável à plataforma selecionada.',
  },
  relevanceExplanation: {
    key: 'global-relevanceExplanation',
    defaultValue:
      'O quão relevante é um {entity, select, topic {tópico} other {subtópico}} em termos de engajamento no período selecionado.',
  },
  clickMessage: {
    key: 'global-clickMessage',
    defaultValue: 'Clique para ver como funciona.',
  },
  videoAvgEngagExplanation: {
    key: 'global-videoAvgEngagExplanation',
    defaultValue: 'Engajamento total (ex. curtidas, comentários e compartilhamentos) por vídeo.',
  },
  videoAvgViewsExplanation: {
    key: 'global-videoAvgViewsExplanation',
    defaultValue:
      'Nossa métrica de produto proprietária com base no número total de visualizações por vídeo, calculada usando uma amostra de vídeo publicada em um ano.',
  },
  topicAvgEngagExplanation: {
    key: 'global-topicAvgEngagExplanation',
    defaultValue:
      'Nossa métrica de produto proprietária é calculada usando métricas de plataformas sociais como comentários, reações e curtidas.',
  },
  topicAvgViewsExplanation: {
    key: 'global-topicAvgViewsExplanation',
    defaultValue: 'O número médio de visualizações dada a plataforma social.',
  },
  topicRelationshipExplanation: {
    key: 'global-topicRelationshipExplanation',
    defaultValue: 'Número total de visualizações por vídeo, calculada usando uma amostra de vídeo publicada em um ano.',
  },
  topicEstimatedViewershipExplanation: {
    key: 'global-topicEstimatedViewershipExplanation',
    defaultValue:
      'O índice de Viewership estimado indica o tamanho dos tópicos, variando de 1 a 10, pelo público que consome esse conteúdo nos últimos 12 meses.',
  },
  topicViewershipDistribution: {
    key: 'global-topicViewershipDistribution',
    defaultValue:
      'Distribuição de Viewership é a representação gráfica que relaciona o Índice de Viewership Estimado e Engajamento por vídeo ou Visualizações por vídeo em um tópico.',
  },
  audienceDemographicsExplanation: {
    key: 'global-audienceDemographicsExplanation',
    defaultValue:
      'A demografia da audiência é estimada por nossa ferramenta de inteligência artificial própria, usando dados públicos de pessoas engajadas com esse conteúdo.',
  },
  videoCountExplanation: {
    key: 'global-videoCountExplanation',
    defaultValue:
      'O gráfico de Contagem de Vídeos (Beta) ainda está em desenvolvimento. Este número pode variar à medida que adicionamos novos vídeos à nossa base de dados.',
  },
  metricNotApplicableToPlatform: {
    key: 'metricNotApplicableToPlatform',
    defaultValue:
      'Esta métrica não é aplicável a {provider, select, fb {Facebook} in {Instagram} tt {TikTok} tw {Twitch} other {YouTube}}',
  },
  metricNotAvailableForPlatform: {
    key: 'global-metricNotAvailableForPlatform',
    defaultValue:
      'Esta métrica não está disponível na API do {provider, select, fb {Facebook} in {Instagram} tt {TikTok} tw {Twitch} other {YouTube}}',
  },
  por: {
    key: 'global-por',
    defaultValue: 'Português',
  },
  spa: {
    key: 'global-spa',
    defaultValue: 'Espanhol',
  },
  eng: {
    key: 'global-eng',
    defaultValue: 'Inglês',
  },
  publicBlockedAccessMessage: {
    key: 'global-publicBlockedAccessMessage',
    defaultValue: 'You must be logged in to have full access to the platform',
  },
  clipboardSuccess: {
    key: 'global-clipboardSuccess',
    defaultValue: 'Conteúdo copiado para a área de transferência.',
  },
  clusterEmptyMessageTitle: {
    key: 'global-clusterEmptyMessageTitle',
    defaultValue:
      'Ainda não temos sugestão de criadores para esse {type, select, topic {tópico} subject {assunto} other {subtópico}}.',
  },
  clusterEmptyMessageText: {
    key: 'global-clusterEmptyMessageText',
    defaultValue: 'Tente buscar um criador da lista abaixo.',
  },
  CreatorClusterSubscriberTooltip: {
    key: 'global-CreatorClusterSubscriberTooltip',
    defaultValue: 'Criadores com mais inscritos que estão falando sobre esse assunto',
  },
  CreatorClusterEngagementTooltip: {
    key: 'global-CreatorClusterEngagementTooltip',
    defaultValue: 'Criadores com conteúdo mais engajado sobre esse assunto',
  },
  CreatorClusterTopicTooltip: {
    key: 'global-CreatorClusterTopicTooltip',
    defaultValue: 'Criadores relevantes que também estão falando sobre este tópico relacionado',
  },
  CreatorClusterSubtopicTooltip: {
    key: 'global-CreatorClusterSubtopicTooltip',
    defaultValue: 'Criadores relevantes que também estão falando sobre este tópico relacionado',
  },
  CreatorClusterBrandsTooltip: {
    key: 'global-CreatorClusterBrandsTooltip',
    defaultValue: 'Marcas que estão falando sobre esse assunto',
  },
  sharePage: {
    key: 'global-sharePage',
    defaultValue: 'Compartilhar página',
  },
  share: {
    key: 'global-share',
    defaultValue: 'Compartilhar',
  },
  paidPartnership: {
    key: 'global-paidPartnership',
    defaultValue: 'Parceria paga',
  },
  password: {
    key: 'global-password',
    defaultValue: 'Senha',
  },
  noResultsFound: {
    key: 'global-noResultsFound',
    defaultValue: 'Não encontramos resultados',
  },
  avgViews: {
    key: 'global-avgViews',
    defaultValue: 'Visu. médias',
  },
  avgEngagement: {
    key: 'global-avgEngagement',
    defaultValue: 'Engajamento médio',
  },
  avgEngag: {
    key: 'global-avgEngag',
    defaultValue: 'Engaj. Med.',
  },
  avgViewsByEngagementTooltip: {
    key: 'global-avgViewsByEngagementTooltip',
    defaultValue: `Engajamento médio: Nossa métrica de produto proprietária é calculada usando métricas de plataformas sociais, como comentários, reações e curtidas.
Visualizações médias: O número médio de visualizações dada a plataforma social.`,
  },
  weekly: {
    key: 'global-weekly',
    defaultValue: 'Semanalmente',
  },
  monthly: {
    key: 'global-monthly',
    defaultValue: 'Mensalmente',
  },
  hide: {
    key: 'global-hide',
    defaultValue: 'Esconder',
  },
  featuredCreatorsTitle: {
    key: 'global-featuredCreatorsTitle',
    defaultValue: 'Criadores relevantes que você precisa conhecer',
  },
  home: {
    key: 'global-home',
    defaultValue: 'Início',
  },
  savedSearch: {
    key: 'global-savedSearch',
    defaultValue: 'Busca salva',
  },
  savedSearches: {
    key: 'global-savedSearches',
    defaultValue: 'Pesquisas salvas',
  },
  goBackToYourSearch: {
    key: 'global-goBackToYourSearch',
    defaultValue: 'Voltar para sua busca',
  },
  creatorsRecommendation: {
    key: 'global-creatorsRecommendation',
    defaultValue: 'Creators recommendation',
  },
  language: {
    key: 'global-language',
    defaultValue: 'Idioma',
  },
  country: {
    key: 'global-country',
    defaultValue: 'País',
  },
  audience: {
    key: 'global-audience',
    defaultValue: 'Audiência',
  },
  affinities: {
    key: 'global-affinities',
    defaultValue: 'Affinities',
  },
  hashtags: {
    key: 'global-hashtags',
    defaultValue: 'Hashtags',
  },
  ages: {
    key: 'global-ages',
    defaultValue: 'Idades',
  },
  genders: {
    key: 'global-genders',
    defaultValue: 'Gêneros',
  },
  all: {
    key: 'global-all',
    defaultValue: 'Todos',
  },
  allCategories: {
    key: 'global-allCategories',
    defaultValue: 'Todas as categorias',
  },
  allAges: {
    key: 'global-allAges',
    defaultValue: 'Todas as idades',
  },
  teens: {
    key: 'global-teens',
    defaultValue: 'Teens',
  },
  young: {
    key: 'global-young',
    defaultValue: 'Young',
  },
  adults: {
    key: 'global-adults',
    defaultValue: 'Adults',
  },
  mature: {
    key: 'global-mature',
    defaultValue: 'Mature',
  },
  midlife: {
    key: 'global-midlife',
    defaultValue: 'Midlife',
  },
  seniors: {
    key: 'global-seniors',
    defaultValue: 'Seniors',
  },
  elders: {
    key: 'global-elders',
    defaultValue: 'Elders',
  },
  searchTerm: {
    key: 'global-searchTerm',
    defaultValue: 'Termo de pesquisa',
  },
  full: {
    key: 'global-full',
    defaultValue: 'Full',
  },
  almostFull: {
    key: 'global-almostFull',
    defaultValue: 'Almost full',
  },
  title: {
    key: 'global-title',
    defaultValue: 'Título',
  },
  engagement: {
    key: 'global-engagement',
    defaultValue: 'Engajamento',
  },
  shortEngagement: {
    key: 'global-shortEngagement',
    defaultValue: 'Engaj.',
  },
  selectThisCreator: {
    key: 'global-selectThisCreator',
    defaultValue: 'Selecione esse criador',
  },
  isTrendingCreatorTooltip: {
    key: 'global-isTrendingCreatorTooltip',
    defaultValue: 'Creators with the fastest growing subscriber base for each tier and provider over the last month',
  },
  subs: {
    key: 'global-subs',
    defaultValue: 'Subs',
  },
  avgEngagementTooltip: {
    key: 'global-avgEngagementTooltip',
    defaultValue:
      'Engajamento médio (por exemplo, curtidas, comentários e compartilhamentos) por vídeo, calculado usando uma amostra de vídeo publicada nos últimos 30 dias. Esta é uma métrica proprietária, calculada pela nossa inteligência artificial, utilizando dados públicos de todas as plataformas.',
  },
  likesPerVideoTooltip: {
    key: 'global-likesPerVideoTooltip',
    defaultValue:
      'Curtidas por vídeo calculadas usando uma amostra de vídeo publicada nos últimos 30 dias. Esta é uma métrica proprietária, calculada pela nossa inteligência artificial utilizando dados públicos de todas as plataformas.',
  },
  avgViewsTooltip: {
    key: 'global-avgViewsTooltip',
    defaultValue:
      'Visualizações médias por vídeo, calculadas com base em uma amostra de vídeo publicada nos últimos 30 dias. Esta é uma métrica proprietária, calculada pela nossa inteligência artificial, utilizando dados públicos de todas as plataformas.',
  },
  brandGroup: {
    key: 'global-brandGroup',
    defaultValue: 'Grupo de marcas',
  },
  tooltipBrandGroup: {
    key: 'global-tooltipBrandGroup',
    defaultValue: 'This Brand is a Facebook Page grouping of differents countries, which share the same metrics.',
  },
  customTopic: {
    key: 'global-customTopic',
    defaultValue: 'Tópico customizado',
  },
  customTopics: {
    key: 'global-customTopics',
    defaultValue: 'Tópicos customizados',
  },
  ownedTopic: {
    key: 'global-ownedTopic',
    defaultValue: 'Tópico próprio',
  },
  ownedTopics: {
    key: 'global-ownedTopics',
    defaultValue: 'Tópicos próprios',
  },
  theme: {
    key: 'global-theme',
    defaultValue: 'Tema',
  },
  themes: {
    key: 'global-themes',
    defaultValue: 'Temas',
  },
  segment: {
    key: 'global-segment',
    defaultValue: 'Segmento',
  },
  segments: {
    key: 'global-segments',
    defaultValue: 'Segmentos',
  },
  subject: {
    key: 'global-subject',
    defaultValue: 'Assunto',
  },
  subjects: {
    key: 'global-subjects',
    defaultValue: 'Assuntos',
  },
  entity: {
    key: 'global-entity',
    defaultValue: 'Entidade',
  },
  entities: {
    key: 'global-entities',
    defaultValue: 'Entidades',
  },
  seeVideos: {
    key: 'global-seeVideos',
    defaultValue: 'Ver vídeos',
  },
  clearAll: {
    key: 'global-clearAll',
    defaultValue: 'Limpar tudo',
  },
  alsoWatchRelationshipDescription: {
    key: 'global-alsoWatchRelationship',
    defaultValue: 'A proprietary metric related to the number of videos an audience watches from another topic.',
  },
  alsoWatchViewsDescription: {
    key: 'global-alsoWatchViews',
    defaultValue: 'Total number of views per video, calculated using a video sample published in a year.',
  },
  alsoWatchEngagementDescription: {
    key: 'global-alsoWatchEngag',
    defaultValue: 'Average engagement (eg. likes, comments and shares) per video.',
  },
  cumulative: {
    key: 'global-cumulative',
    defaultValue: 'Cumulativo',
  },
  noDataAvailableText: {
    key: 'global-noDataAvailableText',
    defaultValue: "There's no data available yet.",
  },
  videoCount: {
    key: 'global-videoCount',
    defaultValue: 'Número de vídeos',
  },
  reports: {
    key: 'global-reports',
    defaultValue: 'Reports',
  },
  personalizedReports: {
    key: 'global-personalizedReports',
    defaultValue: 'Reports Personalizados',
  },
  recurrentReports: {
    key: 'global-recurrentReports',
    defaultValue: 'Reports Recorrentes',
  },
  categoryAvg: {
    key: 'global-categoryAvg',
    defaultValue: 'Média da categoria',
  },
  territoryAvg: {
    key: 'global-territoryAvg',
    defaultValue: 'Média por território',
  },
  customize: {
    key: 'global-customize',
    defaultValue: 'Customizar',
  },
  booleanSearchPlaceholder: {
    key: 'global-booleanSearchPlaceholder',
    defaultValue: 'Você pode separar os termos usando a vírgula (",") para resultados melhores.',
  },
  dragToCreate: {
    key: 'global-dragToCreate',
    defaultValue: 'Arraste para inserir',
  },
  charts: {
    key: 'global-charts',
    defaultValue: 'Gráficos',
  },
  search: {
    key: 'global-search',
    defaultValue: 'Busca',
  },
  bigFile5mb: {
    key: 'global-bigFile5mb',
    defaultValue: 'Seu arquivo é muito pesado, ele deve ter no máximo 5MB',
  },
  uploadingImage: {
    key: 'global-uploadingImage',
    defaultValue: 'Carregando sua imagem...',
  },
  somethingWentWrong: {
    key: 'global-somethingWentWrong',
    defaultValue: 'Oops. Algo deu errado, por favor, tente novamente.',
  },
  requestProblem: {
    key: 'global-requestProblem',
    defaultValue: 'Oops! Tivemos um problema com essa solicitação. Por favor, tente novamente',
  },
  embedDocument: {
    key: 'global-embedDocument',
    defaultValue: 'Incorporar arquivo',
  },
  images: {
    key: 'global-images',
    defaultValue: 'Images',
  },
  templates: {
    key: 'global-templates',
    defaultValue: 'Modelos',
  },
  trends: {
    key: 'global-trends',
    defaultValue: 'Tendências',
  },
  exclude: {
    key: 'global-exclude',
    defaultValue: 'Excluir',
  },
  ara: {
    key: 'global-ara',
    defaultValue: 'Árabe',
  },
  deu: {
    key: 'global-deu',
    defaultValue: 'Alemão',
  },
  cjk: {
    key: 'global-cjk',
    defaultValue: 'CJK (Chinês, Japonês e Coreano)',
  },
  fra: {
    key: 'global-fra',
    defaultValue: 'Francês',
  },
  hin: {
    key: 'global-hin',
    defaultValue: 'Hindi',
  },
  ind: {
    key: 'global-ind',
    defaultValue: 'Indonésio',
  },
  ita: {
    key: 'global-ita',
    defaultValue: 'Italiano',
  },
  jpn: {
    key: 'global-jpn',
    defaultValue: 'Japonês',
  },
  kor: {
    key: 'global-kor',
    defaultValue: 'Coreano',
  },
  rus: {
    key: 'global-rus',
    defaultValue: 'Russo',
  },
  tha: {
    key: 'global-tha',
    defaultValue: 'Tailandês',
  },
  to1: {
    key: 'to1',
    defaultValue: 'Abaixo de 60 segundos',
  },
  from1to3: {
    key: 'from1to3',
    defaultValue: '1 a 3 minutos',
  },
  from3: {
    key: 'from3',
    defaultValue: 'acima de 3 minutos',
  },
  winninAIReport: {
    key: 'global-winninAIReport',
    defaultValue: 'Gerar Winnin Intelligence Report',
  },
  soon: {
    key: 'global-soon',
    defaultValue: 'Em breve',
  },
  territoryAnalysis: {
    key: 'global-territoryAnalysis',
    defaultValue: 'Análise de Território',
  },
  demandSpaces: {
    key: 'global-demandSpaces',
    defaultValue: 'Espaços de demanda',
  },
  territoryAnalysisDescriptionWithDate: {
    key: 'global-territoryAnalysisDescription-withDate',
    defaultValue: 'Tenha Insights de oportunidades dentro de um território nos últimos 12 meses.',
  },
  territoryAnalysisDescription: {
    key: 'global-territoryAnalysisDescription',
    defaultValue: 'Encontre oportunidades dentro de um território a partir de insights data-driven.',
  },
  weeklyAgendaNew: {
    key: 'global-weeklyAgenda-new',
    defaultValue: 'Pauta Semanal',
  },
  weeklyAgendaDescriptionWithDate: {
    key: 'global-weeklyAgendaDescription-withDate',
    defaultValue: 'Se atualize sobre assuntos que estão em alta nos últimos 7 dias.',
  },
  weeklyAgendaDescription: {
    key: 'global-weeklyAgendaDescription',
    defaultValue: 'Se atualize sobre assuntos que estão em alta para compartilhar com seu time.',
  },
  trendAnalysisSoon: {
    key: 'global-trendAnalysis-soon',
    defaultValue: 'Análise de Tendência (em breve)',
  },
  trendAnalysisDescriptionWithDate: {
    key: 'global-trendAnalysisDescription-withDate',
    defaultValue: 'Explore as tendências em alta neste tema',
  },
  creatorsSearch: {
    key: 'global-creatorsSearch',
    defaultValue: 'Busca por Creators',
  },
  creatorsSearchDescription: {
    key: 'global-creatorsSearchDescription',
    defaultValue: 'Saiba quais são os creators que estão bombando dentro de um território',
  },
  weeklyAgenda: {
    key: 'global-weeklyAgenda',
    defaultValue: 'Agenda Semanal',
  },
  trendAnalysis: {
    key: 'global-trendAnalysis',
    defaultValue: 'Análise de Tendência',
  },
  others: {
    key: 'global-others',
    defaultValue: 'Outros',
  },
  trendAnalysisDescription: {
    key: 'global-trendAnalysisDescription',
    defaultValue: 'Entenda quais assuntos estão se destacando nas redes sociais.',
  },
  generateNewResults: {
    key: 'global-generateNewResults',
    defaultValue: 'Gerar novos resultados',
  },
  confirm: {
    key: 'globals-confirm',
    defaultValue: 'Confirmar',
  },
  daily: {
    key: 'globals-daily',
    defaultValue: 'Diário',
  },
  weeklyAdj: {
    key: 'globals-weekly-adj',
    defaultValue: 'Semanal',
  },
  monthlyAdj: {
    key: 'globals-monthly-adj',
    defaultValue: 'Mensal',
  },
  emails: {
    key: 'globals-emails',
    defaultValue: 'E-mails',
  },
  content: {
    key: 'globals-content',
    defaultValue: 'Conteúdo',
  },
  duration: {
    key: 'globals-duration',
    defaultValue: 'Duração',
  },
  territories: {
    key: 'globals-territories',
    defaultValue: 'Territórios',
  },
  niche: {
    key: 'globals-niche',
    defaultValue: 'Nicho',
  },
  niches: {
    key: 'globals-niches',
    defaultValue: 'Nichos',
  },
  demandIntelligence: {
    key: 'global-demandIntelligence',
    defaultValue: 'Demand Intelligence™',
  },
  videoLanguage: {
    key: 'globals-videoLanguage',
    defaultValue: 'Idioma do vídeo',
  },
  creatorCountry: {
    key: 'globals-creatorCountry',
    defaultValue: 'País do criador',
  },
  filters: {
    key: 'globals-filters',
    defaultValue: 'Filtros',
  },
  chart: {
    key: 'globals-chart',
    defaultValue: 'Gráfico',
  },
  table: {
    key: 'globals-table',
    defaultValue: 'Tabela',
  },
  visualization: {
    key: 'globals-visualization',
    defaultValue: 'Visualização',
  },
  metric: {
    key: 'globals-metric',
    defaultValue: 'Métrica',
  },
  videoName: {
    key: 'globals-videoName',
    defaultValue: 'Video name',
  },
  edit: {
    key: 'globals-edit',
    defaultValue: 'Editar',
  },
  editor: {
    key: 'globals-editor',
    defaultValue: 'Editor',
  },
  accept: {
    key: 'globals-accept',
    defaultValue: 'Aceitar',
  },
  decline: {
    key: 'globals-decline',
    defaultValue: 'Recusar',
  },
  barchart: {
    key: 'globals-barchart',
    defaultValue: 'Gráfico de barras',
  },
  columnchart: {
    key: 'globals-columnchart',
    defaultValue: 'Gráfico de colunas',
  },
  bigNumbers: {
    key: 'globals-bigNumbers',
    defaultValue: 'Números grandes',
  },
  linechart: {
    key: 'globals-linechart',
    defaultValue: 'Gráfico de linha',
  },
  scatterchart: {
    key: 'globals-scatterchart',
    defaultValue: 'Gráfico de dispersão',
  },
  histogram: {
    key: 'globals-histogram',
    defaultValue: 'Histograma',
  },
  donut: {
    key: 'globals-donut',
    defaultValue: 'Rosca',
  },
  lastThreeMonths: {
    key: 'globals-lastThreeMonths',
    defaultValue: 'Últimos 3 meses',
  },
  lastSixMonths: {
    key: 'globals-lastSixMonths',
    defaultValue: 'Últimos 6 meses',
  },
  lastTwelveMonths: {
    key: 'globals-lasttwelveMonths',
    defaultValue: 'Últimos 12 meses',
  },
  lastTwoYears: {
    key: 'globals-lastTwoYears',
    defaultValue: 'Últimos 2 anos',
  },
  lastThreeYears: {
    key: 'globals-lastThreeYears',
    defaultValue: 'Últimos 3 anos',
  },
  lastFiveYears: {
    key: 'globals-lastFiveYears',
    defaultValue: 'Últimos 5 anos',
  },
  thirdyDays: {
    key: 'globals-thirdyDays',
    defaultValue: '30 dias',
  },
  threeMonths: {
    key: 'globals-threeMonths',
    defaultValue: '3 meses',
  },
  sixMonths: {
    key: 'globals-sixMonths',
    defaultValue: '6 meses',
  },
  twelveMonths: {
    key: 'globals-twelveMonths',
    defaultValue: '12 meses',
  },
  twoYears: {
    key: 'globals-twoYears',
    defaultValue: '2 anos',
  },
  threeYears: {
    key: 'globals-threeYears',
    defaultValue: '3 anos',
  },
  fiveYears: {
    key: 'globals-fiveYears',
    defaultValue: '5 anos',
  },
  defaultAudienceLabel: {
    key: 'globals-defaultAudienceLabel',
    defaultValue: 'Todos os gêneros, todas as idades, mundialmente',
  },
  chartTypes: {
    key: 'globals-chartTypes',
    defaultValue: 'Tipos de gráficos',
  },
  groupedBy: {
    key: 'globals-groupedBy',
    defaultValue: 'Agrupado',
  },
  videosPerMonth: {
    key: 'globals-videosPerMonth',
    defaultValue: 'Vídeos por mês',
  },
  avgViewsByEngagement: {
    key: 'globals-avgViewsByEngagement',
    defaultValue: 'Med. Eng/Vis',
  },
  averagegViewsByEngagement: {
    key: 'globals-averagegViewsByEngagement',
    defaultValue: 'Média de engajamento por visualização',
  },
  averageEngagement: {
    key: 'globals-averageEngagement',
    defaultValue: 'Média de engajamento',
  },
  averageViews: {
    key: 'globals-averageViews',
    defaultValue: 'Média de visualizações',
  },
  allGenders: {
    key: 'globals-allGenders',
    defaultValue: 'Todos os gêneros',
  },
  worldwide: {
    key: 'globals-worldwide',
    defaultValue: 'Mundialmente',
  },
  relationship: {
    key: 'globals-relationship',
    defaultValue: 'Relacionamento',
  },
  engPerVideo: {
    key: 'globals-engPerVideo',
    defaultValue: 'Engajamento/Vídeo',
  },
  likesPerVideo: {
    key: 'globals-likesPerVideo',
    defaultValue: 'Curtidas/Vídeo',
  },
  viewsPerVideo: {
    key: 'globals-viewsPerVideo',
    defaultValue: 'Visualizações/Vídeos',
  },
  peopleAlsoWatch: {
    key: 'globals-peopleAlsoWatch',
    defaultValue: 'Afinidade',
  },
  versionHistory: {
    key: 'globals-versionHistory',
    defaultValue: 'Histórico de versões',
  },
  close: {
    key: 'globals-close',
    defaultValue: 'Fechar',
  },
  onlyVisualization: {
    key: 'globals-onlyVisualization',
    defaultValue: 'Somente visualização',
  },
  notEligibleWinninAIReport: {
    key: 'globals-notEligibleWinninAIReport',
    defaultValue:
      'Este assunto não tem vídeos suficientes para criar uma {type, select, territory_analysis {análise de território} weekly_schedule {pauta semanal} trend_analysis {análise de tendência} search_creators {busca por creators} other {análise de território}}. Você pode continuar tendo insights criando um report para um caso de uso diferente.',
  },
  estimatedValue: {
    key: 'global-estimatedValue',
    defaultValue: '(este ponto tem um valor estimado)',
  },
  allReferences: {
    key: 'global-allReferences',
    defaultValue: 'Todas as referências salvas',
  },
  allReferencesShortTitle: {
    key: 'global-allReferences-shortTitle',
    defaultValue: 'Todas as referências',
  },
  create: {
    key: 'global-create',
    defaultValue: 'Criar',
  },
  createdBy: {
    key: 'global-createdBy',
    defaultValue: 'Created by',
  },
  savedReferences: {
    key: 'global-savedReferences',
    defaultValue: 'Referências Salvas',
  },
  savedReferencesAmount: {
    key: 'global-savedReferences-amount',
    defaultValue: '{pinsAmount, plural, one {# Referência} other {# Referências}}',
  },
  savedReferencesSubtitle: {
    key: 'global-savedReferencesSubtitle',
    defaultValue: 'O que foi salvo por você e seu time até agora',
  },
  createNewFolder: {
    key: 'global-createNewFolder',
    defaultValue: 'Criar nova pasta',
  },
  searchContentInFolder: {
    key: 'global-searchContentInFolder',
    defaultValue: `Procurar por conteúdos em “{folderTitle}”`,
  },
  creatorsCount: {
    key: 'global-creatorsCount',
    defaultValue: '{creatorsCount} {creatorsCount, plural, one {Creator} other {Creators}}',
  },
  topicsCount: {
    key: 'global-topicsCount',
    defaultValue: '{topicsCount} {topicsCount, plural, one {Tópico} other {Tópicos}}',
  },
  videosCount: (parameters: { videosCount: string }) => ({
    key: 'global-videosCount',
    parameters,
    defaultValue: '{videosCount} {videosCount, plural, one {Vídeo} other {Vídeos}}.',
  }),
  videosCountWithTerm: (parameters: { term: string; videosCount: string }) => ({
    key: 'global-videosCountWithTerm',
    parameters,
    defaultValue: '{videosCount} {videosCount, plural, one {Vídeo} other {Vídeos}} com "{term}"',
  }),
  allJobs: {
    key: 'global-allJobs',
    defaultValue: 'Todos os jobs',
  },
  allJobsAsDashboard: {
    key: 'global-allJobs-asDashboard',
    defaultValue: 'Todos os dashboards',
  },
  dashboard: {
    key: 'global-dashboard',
    defaultValue: 'Dashboard',
  },
  dashboards: {
    key: 'global-dashboards',
    defaultValue: 'Dashboards',
  },
  formats: {
    key: 'global-formats',
    defaultValue: 'Formatos',
  },
  noResultsSearchOrFilter: {
    key: 'global-noResultsSearchOrFilter',
    defaultValue: 'Não encontramos resultados para essa busca ou filtro.',
  },
  noResultsSearchOrFilterMessage: {
    key: 'global-searchNoResultsMessage',
    defaultValue: 'Utilize outros termos de busca ou filtros para encontrarmos novos resultados.',
  },
  noDataFound: {
    key: 'global-noDataFound',
    defaultValue: 'Não encontramos dados suficientes',
  },
  noDataFoundMessage: {
    key: 'global-noDataFoundMessage',
    defaultValue:
      'Este assunto não tem vídeos o suficiente para fazermos nossas análises e entregarmos insights para você. Edite este tópico e escolha outros filtros para ter um novo resultado.',
  },
  noDataFoundMessageSmall: {
    key: 'global-noDataFoundMessageSmall',
    defaultValue:
      'Este assunto não tem vídeos o suficiente para fazermos nossas análises e entregarmos insights para você.',
  },
  foldersLimitStatus: {
    key: 'global-foldersLimitStatus',
    defaultValue: '{totalFolders}/{foldersLimit} pastas',
  },
  foldersLimitMessage: {
    key: 'global-foldersLimitMessage',
    defaultValue: 'Limite de pastas para este job atingido',
  },
  foldersLimitMessageAsDashboard: {
    key: 'global-foldersLimitMessage-asDashboard',
    defaultValue: 'Limite de pastas para este dashboard atingido',
  },
  bubbleChart: {
    key: 'global-bubbleChart',
    defaultValue: 'Gráfico de bolhas',
  },
  providerTitle: {
    key: 'global-providerTitle',
    defaultValue: 'Plataforma',
  },
  providers: {
    key: 'global-providers',
    defaultValue: 'Provedores',
  },
  languageTitle: {
    key: 'global-languageTitle',
    defaultValue: 'Língua',
  },
  performance: {
    key: 'global-performance',
    defaultValue: 'Desempenho',
  },
  relevanceOverTime: {
    key: 'global-relevanceOverTime',
    defaultValue: 'Relevância ao longo do tempo',
  },
  generalProviderTitle: {
    key: 'global-generalProviderTitle',
    defaultValue: 'Geral',
  },
  disabledOptionUpgradePlan: {
    key: 'global-disabledOptionUpgradePlan',
    defaultValue:
      'Você não possui acesso a essa opção. Entre em contato com nossa equipe e faça um upgrade do seu plano.',
  },
  first30Days: {
    key: 'global-first30Days',
    defaultValue: 'First 30 days',
  },
  infoHiddenByCreator: {
    key: 'global-infoHiddenByCreator',
    defaultValue: 'Informação ocultada pelo criador',
  },
  trending: {
    key: 'global-trending',
    defaultValue: 'Tendência',
  },
  crescimento: {
    key: 'global-crescimento',
    defaultValue: 'Em crescimento',
  },
  queda: {
    key: 'global-queda',
    defaultValue: 'Em queda',
  },
  insightsAI: {
    key: 'global-insightsAI',
    defaultValue: 'Insight por Winnin Intelligence',
  },
  territoryMetricsMessage: {
    key: 'global-territoryMetricsMessage',
    defaultValue:
      'As métricas nesta tabela são baseadas nos vídeos que fazem parte do território macro. Para entender o comportamento geral do território, acesse suas páginas individualmente.',
  },
  shareEngagement: {
    key: 'global-shareEngagement',
    defaultValue: 'Share de engajamento',
  },
  shareViews: {
    key: 'global-shareViews',
    defaultValue: 'Share de visualizações',
  },
  shareContent: {
    key: 'global-shareContent',
    defaultValue: 'Share de conteúdo',
  },
  shareVideo: {
    key: 'global-shareVideo',
    defaultValue: 'Share de vídeos',
  },
  newJobLimitReached: ({ jobsCount, jobsLimit }) => ({
    key: 'global-newJobLimitReached',
    parameters: { jobsCount, jobsLimit },
    defaultValue: `Esse workspace está usando {jobsCount} de {jobsLimit} disponíveis.
Se você estiver tendo problemas com esse limite, entre em contato através do nosso chat.`,
  }),
  ordenadoPor: {
    key: 'global-ordenadoPor',
    defaultValue: 'Ordenado por',
  },
  followersSubs: {
    key: 'global-followersSubs',
    defaultValue: 'Seguidores/Inscritos',
  },
  CreatorClusterSubscriber: {
    key: 'global-CreatorClusterSubscriber',
    defaultValue: 'Criadores com <strong>mais inscritos</strong> que lhe darão alcance',
  },
  CreatorClusterEngagement: {
    key: 'global-CreatorClusterEngagement',
    defaultValue: 'Criadores <strong>mais engajados</strong>, que fazem a conversa acontecer',
  },
  CreatorClusterTopic: {
    key: 'global-CreatorClusterTopic',
    defaultValue: 'Criadores que estão falando sobre <strong>{topic}</strong> e também <strong>{related}</strong>',
  },
  CreatorClusterBrands: {
    key: 'global-CreatorClusterBrands',
    defaultValue: '<strong>Marcas mais engajadas</strong> que fazem a conversa acontecer',
  },
  CreatorClusterTrending: {
    key: 'global-CreatorClusterTrend',
    defaultValue: 'Criadores em <strong>tendência</strong> que tem ganhado seguidores rapidamente',
  },
  CreatorClusterSubscriberForTooltip: {
    key: 'global-CreatorClusterSubscriberForTooltip',
    defaultValue: 'Criadores com mais inscritos que lhe darão alcance',
  },
  CreatorClusterEngagementForTooltip: {
    key: 'global-CreatorClusterEngagementForTooltip',
    defaultValue: 'Criadores mais engajados que fazem a conversa acontecer',
  },
  CreatorClusterTopicForTooltip: {
    key: 'global-CreatorClusterTopicForTooltip',
    defaultValue: 'Criadores que estão falando sobre {topic} e também {related}',
  },
  CreatorClusterBrandsForTooltip: {
    key: 'global-CreatorClusterBrandsForTooltip',
    defaultValue: 'Marcas mais engajadas que fazem a conversa acontecer',
  },
  CreatorClusterTrendingForTooltip: {
    key: 'global-CreatorClusterTrendForTooltip',
    defaultValue: 'Criadores em tendência que tem ganhado seguidores rapidamente',
  },
  recomendacoes: {
    key: 'global-recomendacoes',
    defaultValue: 'Recomendações',
  },
  icon: {
    key: 'global-icon',
    defaultValue: 'Criadores icon',
  },
  mid: {
    key: 'global-mid',
    defaultValue: 'Criadores mid ',
  },
  micro: {
    key: 'global-micro',
    defaultValue: 'Criadores micro',
  },
  top: {
    key: 'global-top',
    defaultValue: 'Criadores top ',
  },
  iconCreatorDescription: {
    key: 'global-iconDescription',
    defaultValue: 'Criadores com mais de 5M de Seguidores/Subs ',
  },
  midCreatorDescription: {
    key: 'global-midDescription',
    defaultValue: 'Criadores entre 200k e 1M de Seguidores/Subs',
  },
  microCreatorDescription: {
    key: 'global-microDescription',
    defaultValue: 'Criadores até 200k',
  },
  topCreatorDescription: {
    key: 'global-topDescription',
    defaultValue: 'Criadores entre 1 e 5M de Seguidores/Subs',
  },
  territory: {
    key: 'global-territory',
    defaultValue: 'Território',
  },
  todas: {
    key: 'global-todas',
    defaultValue: 'Todas',
  },
  newAudience: {
    key: 'global-newAudience',
    defaultValue: 'Nova Audiência',
  },
  savedAudiences: {
    key: 'global-savedAudiences',
    defaultValue: 'Audiências salvas',
  },
  onlyYoutubeDemographicsMessage: {
    key: 'global-onlyYoutubeDemographicsMessage',
    defaultValue: 'Dados de demografia apenas disponíveis para youtube',
  },
  noAudiencesStored: {
    key: 'global-noAudiencesStored',
    defaultValue: 'No audiences currently stored',
  },
  saveAudience: {
    key: 'global-saveAudience',
    defaultValue: 'Salvar audiência',
  },
  saving: {
    key: 'global-saving',
    defaultValue: 'Saving...',
  },
  analyzeTerritory: {
    key: 'global-analyzeTerritory',
    defaultValue: 'Analise um território',
  },
  compareBrandsOrCreators: {
    key: 'global-compareBrandsOrCreators',
    defaultValue: 'Compare marcas ou criadores',
  },
  trackYourReports: {
    key: 'global-trackYourReports',
    defaultValue: 'Acompanhe seus reports',
  },
  cantCollectPlatformData: {
    key: 'global-cantCollectPlatformData',
    defaultValue: 'Por enquanto não conseguimos coletar este dado para a plataforma selecionada.',
  },
  seeLess: {
    key: 'global-seeLess',
    defaultValue: 'Ver menos',
  },
  notEnoughDataMessage: {
    key: 'global-notEnoughDataMessage',
    defaultValue: 'Não encontramos dados suficientes para fazermos nossas análises e entregarmos insights para você.',
  },
  yourCompetitors: {
    key: 'global-yourCompetitors',
    defaultValue: 'Seus competidores',
  },
  yourBrand: {
    key: 'global-yourBrand',
    defaultValue: 'Sua marca',
  },
  ugc: {
    key: 'global-ugc',
    defaultValue: 'User generated content',
  },
  optional: {
    key: 'global-optional',
    defaultValue: 'Opcional',
  },
  requiredField: {
    key: 'global-requiredField',
    defaultValue: 'Campo obrigatório',
  },
  conclude: {
    key: 'global-conclude',
    defaultValue: 'Concluir',
  },
  proprietaryChannels: {
    key: 'global-proprietaryChannels',
    defaultValue: 'Canais proprietários',
  },
  fillRequiredFieldsToProceedEditing: {
    key: 'global-fillRequiredFieldsToProceedEditing',
    defaultValue: 'Preencha todos os campos obrigatórios para prosseguir com a edição',
  },
  saveChanges: {
    key: 'global-saveChanges',
    defaultValue: 'Salvar alterações',
  },
  show: {
    key: 'global-show',
    defaultValue: 'Mostrar',
  },
  send: {
    key: 'global-send',
    defaultValue: 'Enviar',
  },
  competitors: {
    key: 'global-competitors',
    defaultValue: 'Concorrentes',
  },
  competitor: {
    key: 'global-competitor',
    defaultValue: 'Concorrente',
  },
  searchPlaceholder: {
    key: 'global-searchPlaceholder',
    defaultValue: 'Você pode usar " ", (  ), OR, AND ou NOT para melhorar sua pesquisa',
  },
  dashboardLimitMessage: {
    key: `dashboardLimitMessage`,
    defaultValue: 'O limite de dashboards neste Workspace foi atingido',
  },
  lockedDashboardMessage: {
    key: 'global-lockedDashboardMessage',
    defaultValue: 'Desbloqueie seu dashboard para editar seu conteúdo e ter os dados atualizados em tempo real',
  },
  lockedAddComponentMessage: {
    key: 'global-lockedAddComponentMessage',
    defaultValue: 'Você não pode adicionar componentes ao dashboard enquanto está com ele bloqueado',
  },
  lock: {
    key: 'global-lock',
    defaultValue: 'Bloquear',
  },
  unlock: {
    key: 'global-unlock',
    defaultValue: 'Desbloquear',
  },
  otherBrand: {
    key: 'global-otherBrand',
    defaultValue: 'Outra marca',
  },
  myBrand: {
    key: 'global-myBrand',
    defaultValue: 'Minha marca',
  },
  myCompetitor: {
    key: 'global-myCompetitor',
    defaultValue: 'Meu concorrente',
  },
  useAdvancedMode: {
    key: 'global-useAdvancedMode',
    defaultValue: 'Usar modo avançado',
  },
  exitAdvancedMode: {
    key: 'global-exitAdvancedMode',
    defaultValue: 'Sair do modo avançado',
  },
  emptyDataTitle: {
    key: 'global-emptyDataTitle',
    defaultValue: 'Data coming soon!',
  },
  emptyDataMessage: {
    key: 'global-emptyDataMessage',
    defaultValue: 'There’s no data available yet.',
  },
  low: {
    key: 'global-low',
    defaultValue: 'Low',
  },
  high: {
    key: 'global-high',
    defaultValue: 'High',
  },
  included: {
    key: 'global-included',
    defaultValue: 'Incluído',
  },
  excluded: {
    key: 'global-excluded',
    defaultValue: 'Excluído',
  },
  lastEdited: {
    key: 'global-lastEdited',
    defaultValue: 'Last edited',
  },
  overview: {
    key: 'global-overview',
    defaultValue: 'Visão geral',
  },
  owned: {
    key: 'global-owned',
    defaultValue: 'Owned',
  },
  earned: {
    key: 'global-earned',
    defaultValue: 'Earned',
  },
  earnedUgc: {
    key: 'global-earned-ugc',
    defaultValue: 'Earned (UGC)',
  },
  downloadImage: {
    key: 'global-downloadImage',
    defaultValue: 'Baixar imagem',
  },
  embed: {
    key: 'global-embed',
    defaultValue: 'Incorporar',
  },
  paid: {
    key: 'global-paid',
    defaultValue: 'Paid',
  },
  favorite: {
    key: 'global-favorite',
    defaultValue: 'Favorito',
  },
  favorites: {
    key: 'global-favorites',
    defaultValue: 'Favoritos',
  },
  allProviders: {
    key: 'global-allProviders',
    defaultValue: 'Todos os providers',
  },
  brands: {
    key: 'global-brands',
    defaultValue: 'Marcas',
  },
  allBrands: {
    key: 'global-allBrands',
    defaultValue: 'Todas as marcas',
  },
  loading: {
    key: 'global-loading',
    defaultValue: 'Carregando',
  },
  shareDescription: ({ context }) => ({
    key: 'global-shareDescription',
    parameters: { context },
    defaultValue: `Encontrei um insight na Winnin Intelligence: {context}`,
  }),
  or: {
    key: 'global-or',
    defaultValue: 'ou',
  },
  results: {
    key: 'global-results',
    defaultValue: '{results} {results, plural, one {Resultado} other {Resultados}}',
  },
  relatedResults: {
    key: 'global-relatedResults',
    defaultValue: '{results} {results, plural, one {Resultado relacionado} other {Resultados relacionados}}',
  },
  allLanguages: {
    key: 'global-allLanguages',
    defaultValue: 'All languages',
  },
  insightsByZai: {
    key: 'global-insightsByZai',
    defaultValue: 'Insights by Zai',
  },
  byZai: {
    key: 'global-byZai',
    defaultValue: 'by Zai',
  },
  generationBriefing: {
    key: 'global-generationBriefing',
    defaultValue: 'Gerar briefing',
  },
  dontHaveAccessContent: {
    key: 'global-dontHaveAccessContent',
    defaultValue: `Você ainda não tem acesso a este conteúdo. Para visualizar, atualize sua conta.`,
  },
  custom: {
    key: 'global-custom',
    defaultValue: 'Custom',
  },
  pointsValue: pointsValue => ({
    key: 'global-pointsValue',
    parameters: {
      pointsValue,
    },
    defaultValue: '{pointsValue} pontos',
  }),
  shareOfAttention: {
    key: 'global-shareOfAttention',
    defaultValue: 'Share of Attention',
  },
  updatedAtTimezone: ({ date, hours, timezone }) => ({
    key: 'global-updatedAtTimezone',
    parameters: {
      date,
      hours,
      timezone,
    },
    defaultValue: 'Atualizado em {date} às {hours} no {timezone}',
  }),
  generatedAtTimezone: ({ date, hours, timezone }) => ({
    key: 'global-generatedAtTimezone',
    parameters: {
      date,
      hours,
      timezone,
    },
    defaultValue: 'Gerado em {date} às {hours} no {timezone}',
  }),
  lastOs: {
    key: 'global-last-os',
    defaultValue: 'Últimos',
  },
  lastAs: {
    key: 'global-last-as',
    defaultValue: 'Últimas',
  },
  days: count => ({
    key: 'global-days',
    parameters: {
      count,
    },
    defaultValue: '{count, plural, one {# dia} other {# dias}}',
  }),
  weeks: count => ({
    key: 'global-weeks',
    parameters: {
      count,
    },
    defaultValue: '{count, plural, one {# semana} other {# semanas}}',
  }),
  months: count => ({
    key: 'global-months',
    parameters: {
      count,
    },
    defaultValue: '{count, plural, one {# mês} other {# meses}}',
  }),
  positive: {
    key: 'global-positive',
    defaultValue: 'Positivo',
  },
  negative: {
    key: 'global-negative',
    defaultValue: 'Negativo',
  },
  neutral: {
    key: 'global-neutral',
    defaultValue: 'Neutro',
  },
  ranking: {
    key: 'global-ranking',
    defaultValue: 'Ranking',
  },
  'LoadingZai-loadingText': {
    key: 'InputSuggestedList-CustomOptions-loading',
    defaultValue: 'Carregando...',
  },
  cantGenerateBriefing: {
    key: 'global-cantGenerateBriefing-tooltip',
    defaultValue:
      'Para gerar um briefing relevante, a Zai precisa que sua marca tenha publicado ao menos um vídeo nas próprias contas nos últimos 12 meses.',
  },
  briefing: {
    key: 'global-briefing',
    defaultValue: 'Briefing',
  },
  zai: {
    key: 'global-zai',
    defaultValue: 'Zai',
  },
  pending: {
    key: 'global-pending',
    defaultValue: 'Pendente',
  },
  draft: {
    key: 'global-draft',
    defaultValue: 'Rascunho',
  },
  select: {
    key: 'global-select',
    defaultValue: 'Selecione',
  },
  type: {
    key: 'global-type',
    defaultValue: 'Tipo',
  },
  contentType: {
    key: 'global-contentType',
    defaultValue: 'Tipo de conteúdo',
  },
  thisMonth: {
    key: 'global-thisMonth',
    defaultValue: 'Este mês',
  },
  otherMonths: {
    key: 'global-otherMonths',
    defaultValue: 'Outros meses',
  },
  quarter: {
    key: 'global-quarter',
    defaultValue: 'Quarter',
  },
  tag: {
    key: 'global-tag',
    defaultValue: 'Tag',
  },
  tags: {
    key: 'global-tags',
    defaultValue: 'Tags',
  },
  dashboardChartDataUniverse: ({ engagement, views, videos }) => ({
    key: 'global-dashboardChartDataUniverse',
    parameters: { engagement, views, videos },
    defaultValue: 'Universo de dados: {engagement} de engajamento, {views} de visualizações, {videos} de vídeos.',
  }),
  dashboardChartVideosDataUniverse: ({ likes, views }) => ({
    key: 'global-dashboardChartVideosDataUniverse',
    parameters: { likes, views },
    defaultValue: 'Universo de dados: {likes} curtidas, {views} visualizações',
  }),
  exportCsv: {
    key: 'global-exportCsv',
    defaultValue: 'Exportar CSV',
  },
  csvEmail: {
    key: 'global-csvEmail',
    defaultValue: 'Dados enviados com sucesso. Você receberá um e-mail com o CSV em instantes.',
  },
  startDownload: {
    key: 'global-startDownload',
    defaultValue: 'Iniciando o seu download...',
  },
  downloadSuccess: {
    key: 'global-downloadSuccess',
    defaultValue: 'Download concluído com sucesso!',
  },
  dashboardWithPlural: ({ dashboardCount }) => ({
    key: 'global-dashboardWithPlural',
    parameters: { dashboardCount },
    defaultValue: '{dashboardCount, plural, one {# Dashboard} other {# Dashboards}}',
  }),
  loadMore: {
    key: 'global-loadMore',
    defaultValue: 'Carregar mais',
  },
  moveToFolder: {
    defaultValue: 'Mover para pasta',
    key: 'global-moveToFolder',
  },
  name: {
    defaultValue: 'Nome',
    key: 'global-name',
  },
  nicheLimitMessage: nicheLimit => ({
    key: 'global-nicheLimitMessage',
    parameters: {
      nicheLimit,
    },
    defaultValue: 'Você só pode selecionar até {nicheLimit} nichos para visualizar por vez',
  }),
  allTerritories: {
    key: 'global-allTerritories',
    defaultValue: 'Todos os territórios',
  },
  update: {
    key: 'global-update',
    defaultValue: 'Atualizar',
  },
  publishedDashWarning: {
    key: 'global-publishedDashWarning',
    defaultValue: 'Um dashboard publicado como report não pode ser público',
  },
  date: {
    key: 'global-date',
    defaultValue: 'Data',
  },
  hotTopics: {
    key: 'global-hotTopics',
    defaultValue: 'Tópicos quentes',
  },
  mostEngaged: {
    key: 'global-mostEngaged',
    defaultValue: 'Mais engajados',
  },
  mostGrowth: {
    key: 'global-filter-mostGrowth',
    defaultValue: 'Maior crescimento',
  },
  copyTerritoryQuery: {
    defaultValue: 'Copiar query',
    key: 'global-copyTerritoryQuery',
  },
  territoryQueryCopied: {
    defaultValue: 'Query copiada para a área de transferência',
    key: 'global-territoryQueryCopied',
  },
  generateFreeReport: {
    key: 'global-generateFreeReport',
    defaultValue: 'Gerar report grátis',
  },
  from: {
    defaultValue: 'De',
    key: 'global-from',
  },
  to: {
    defaultValue: 'À',
    key: 'global-to',
  },
  overtime: {
    key: 'global-overtime',
    defaultValue: 'Evolução',
  },
  winninTopics: {
    defaultValue: 'Winnin topics',
    key: 'global-winninTopics',
  },
  tgl: {
    defaultValue: 'Tagalog',
    key: 'global-tgl',
  },
  zho: {
    defaultValue: 'Chinês',
    key: 'global-zho',
  },
  createReport: {
    defaultValue: 'Criar Report',
    key: 'global-createReport',
  },
  reset: {
    defaultValue: 'Restaurar',
    key: 'global-reset',
  },
  viewsOverTime: {
    defaultValue: 'Visualização ao longo do tempo',
    key: 'global-viewsOverTime',
  },
  liveEvents: {
    defaultValue: 'Eventos ao vivo',
    key: 'global-liveEvents',
  },
  happeningNow: {
    defaultValue: 'Acontecendo agora',
    key: 'global-happeningNow',
  },
  launches: {
    defaultValue: 'Lançamentos',
    key: 'global-launches',
  },
  ended: {
    defaultValue: 'Encerrado',
    key: 'global-ended',
  },
  inProgress: {
    defaultValue: 'Em progresso',
    key: 'global-inProgress',
  },
  mostRecent: {
    defaultValue: 'Mais recente',
    key: 'global-mostRecent',
  },
  alphabeticalOrder: {
    defaultValue: 'Ordem alfabética',
    key: 'global-alphabeticalOrder',
  },
  ownedTopicsLimit: {
    defaultValue:
      'Você atingiu o limite do seu plano. Faça um upgrade do plano para salvar mais tópicos próprios, ou exclua alguns dos seus tópicos salvos.',
    key: 'global-ownedTopicsLimit',
  },
  reportName: {
    key: 'global-reportName',
    defaultValue: 'Nome do report',
  },
  hotTopic: {
    key: 'global-hotTopic',
    defaultValue: 'Hot topic',
  },
  see: {
    key: 'global-see',
    defaultValue: 'Ver',
  },
  adjustFiltersToFindResults: {
    key: 'global-adjustFiltersToFindResults',
    defaultValue: 'Ajuste os filtros para encontrar resultados.',
  },
  volume: {
    key: 'global-volume',
    defaultValue: 'Volume',
  },
  variety: {
    key: 'global-variety',
    defaultValue: 'Variedade',
  },
  velocity: {
    key: 'global-velocity',
    defaultValue: 'Velocidade',
  },
  virality: {
    key: 'global-virality',
    defaultValue: 'Viralização',
  },
  followersCount: range => ({
    key: 'global-followersCount',
    parameters: { range },
    defaultValue: '{range} seguidores',
  }),
  creatorTier: {
    key: 'global-creatorTier',
    defaultValue: 'Creator Tier',
  },
  allTiers: {
    key: 'global-allTiers',
    defaultValue: 'All Tiers',
  },
  totalEngagementExplanation: {
    key: 'global-totalEngagementExplanation',
    defaultValue:
      'Exibe a evolução do engajamento acumulado dos vídeos publicados durante o período selecionado, somando as interações recebidas ao longo do tempo.',
  },
}

export default TOLGEE_GLOBALS
